import { render, staticRenderFns } from "./ModuleDetailTable.vue?vue&type=template&id=436dc0c8"
import script from "./ModuleDetailTable.vue?vue&type=script&lang=js"
export * from "./ModuleDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports